import React from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import type { SerializedStyles } from '@emotion/react';
import type { WPublicWeddingView, WThemeComponentFontView } from '@zola/svc-web-api-ts-client';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors';
import { FullComponentFontView } from './util/mappers';

export type ThemeContextType = {
  components: {
    Button: StyledComponent<React.ButtonHTMLAttributes<HTMLButtonElement>>;
    CmsEntityBodyLink: StyledComponent<React.AnchorHTMLAttributes<HTMLAnchorElement>>;
    globalBodyFontStyle: SerializedStyles;
    globalHeaderFontStyle: SerializedStyles;
    globalHeaderFontValues: FullComponentFontView;
    globalBodyFontValues: FullComponentFontView;
    globalAccentColor: string;
    globalInputFieldStyles: SerializedStyles;
    cmsEntityComponentHeaderFontValues: FullComponentFontView;
    cmsEntityComponentBodyFontValues: FullComponentFontView;
    cmsEntityComponentBodyFont2Values: FullComponentFontView;
    cmsEntityComponentHeaderFontStyles: SerializedStyles;
    cmsEntityComponentBodyFontStyles: SerializedStyles;
    cmsEntityComponentBodyFont2Styles: SerializedStyles;
    backgroundColors: {
      nav: string;
      homepageContent: string;
      content: string;
      global: string;
    };
  };
  highlightedComponents: string[];
  wedding?: WPublicWeddingView;
  inPreview?: boolean;
};

export const DEFAULT_HEADER_FONT_VALUES: FullComponentFontView = {
  fontFamily: 'Proxima Nova',
  isCursive: false,
  fontSize: 40,
  letterSpacing: 0,
  lineHeight: 60,
  textTransform: ('NONE' as unknown) as WThemeComponentFontView.TextTransformEnum,
  color: '000000',
  fontWeight: ('NORMAL' as unknown) as WThemeComponentFontView.FontWeightEnum,
};
export const DEFAULT_BODY_FONT_VALUES = {
  fontFamily: 'Proxima Nova',
  isCursive: false,
  fontSize: 20,
  letterSpacing: 0,
  lineHeight: 32,
  textTransform: ('NONE' as unknown) as WThemeComponentFontView.TextTransformEnum,
  color: '000000',
  fontWeight: ('NORMAL' as unknown) as WThemeComponentFontView.FontWeightEnum,
};
export const DEFAULT_ACCENT_COLOR = COLORS.NAVY.substring(1);

export const DEFAULT_BACKGROUND_COLOR = 'FFFFFF';

export const ThemeContext = React.createContext<ThemeContextType>({
  components: {
    Button: styled.button``,
    CmsEntityBodyLink: styled.a``,
    globalBodyFontStyle: { name: '', styles: '' },
    globalHeaderFontStyle: { name: '', styles: '' },
    globalBodyFontValues: DEFAULT_BODY_FONT_VALUES,
    globalHeaderFontValues: DEFAULT_HEADER_FONT_VALUES,
    globalAccentColor: DEFAULT_ACCENT_COLOR,
    globalInputFieldStyles: { name: '', styles: '' },
    cmsEntityComponentHeaderFontValues: DEFAULT_HEADER_FONT_VALUES,
    cmsEntityComponentBodyFontValues: DEFAULT_BODY_FONT_VALUES,
    cmsEntityComponentBodyFont2Values: DEFAULT_BODY_FONT_VALUES,
    cmsEntityComponentHeaderFontStyles: { name: '', styles: '' },
    cmsEntityComponentBodyFontStyles: { name: '', styles: '' },
    cmsEntityComponentBodyFont2Styles: { name: '', styles: '' },
    backgroundColors: {
      nav: DEFAULT_BACKGROUND_COLOR,
      homepageContent: DEFAULT_BACKGROUND_COLOR,
      content: DEFAULT_BACKGROUND_COLOR,
      global: DEFAULT_BACKGROUND_COLOR,
    },
  },
  highlightedComponents: [],
  wedding: {},
  inPreview: false,
});
